import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Art from './pages/Art';
import Paper from './pages/projects/Paper';
import Research from './pages/Research';
import CV from './pages/CV';
import Kryptogramms from './pages/Kryptogramms';
import "./styles/style.css"; // Import global styles

function App() {
  return (
    <Router>
      {/* Global color splash background */}
      <div id="color-splash-bg" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/art" element={<Art />} />
        <Route path="/paper" element={<Paper />} />
        <Route path="/research" element={<Research />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/kryptogramms" element={<Kryptogramms />} />
      </Routes>
    </Router>
  );
}

export default App;
